export default __webpack_public_path__ + "img/sad-vote.fc003c9.svg";